import React, { useState, useEffect } from "react";
import DatePicker from "./datePicker";
import { getNotes, getNotesData } from "../../../../actions/configuration";
import { dateFormat } from "../../../../lib/functions";
import Loader from "../../../../lib/ui/loader/Loader";
import NoData from "../../../../lib/ui/nodata/NoData";
import { Button, TextField } from "@material-ui/core";
import { API } from "aws-amplify";
import InternalNote from "./internalNote";
import { updateNotes } from "../../../../actions/configuration";
import ReactQuill from "react-quill";
// import Button from "../../../../lib/ui/buttons/Button";
// import ReactQuillEditor from "../../../../components/reactQuillEditor";

const MedicalHistory = ({ data }) => {
    const [search, setSearch] = useState(false);
    const [res, setRes] = useState([]);     
    const [loading, setLoading] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [editedContent, setEditedContent] = useState("");
    const [date, setDate] = useState(() => {
        const startOfDay = (timestamp) => {
          const date = new Date(timestamp);
          date.setHours(0, 0, 0, 0);
          return date.getTime();
        };
      
        const endOfDay = (timestamp) => {
          const date = new Date(timestamp);
          date.setHours(23, 59, 59, 999);
          return date.getTime();
        };
      
        return {
          from: data?.startTime ? startOfDay(data.startTime) : null,
          to: data?.endTime ? endOfDay(data.endTime) : null,
        };
      });      
    
    const handleGet = () => {
        setLoading(true);
        let query = `?did=${data?.doctorId}&aid=${data?.appointmentId}`;
        getNotes(query)
            .then((resp) => {
                resp && resp.data && setRes([resp.data]);
                setLoading(false);
            })
            .catch((e) => {
                console.log("e.........:", e);
                if(API.isCancel(e)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        handleGet();
    }, []);

    const handleGetDates = () => {
        setLoading(true);
        let query = `?did=${data?.doctorId}&pid=${data?.patientId}&from=${date?.from}&to=${date?.to}`;
        getNotesData(query)
            .then((resp) => {
                resp && resp.data && setRes(resp.data);
                setSearch(false);
                setLoading(false);
            })
            .catch((e) => {
                console.log("e.........:", e);
                setSearch(false);
                if(API.isCancel(e)) {             
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        if (search) {
            handleGetDates();
        }
    }, [search]);

    const handleEdit = (index, content) => {
        setEditIndex(index);
        setEditedContent(content);
    };

    const handleCancel = () => {
        setEditIndex(null);
        setEditedContent("");
    };

    const handleSave = (noteData) => {
        setLoading(true)
        const body = {
            dId: data?.doctorId,
            id: noteData._id,          
            notes: `<p>${editedContent}</p>`, 
            pdob: noteData.pdob       
        };
    
        console.log("Payload to update notes:", body); 
    
        updateNotes(body)
            .then(() => {
                const updatedRes = [...res];
                updatedRes[editIndex].notes = `<p>${editedContent}</p>`;
                setRes(updatedRes);
                setEditIndex(null);
                setEditedContent(""); 
                setLoading(false)
            })
            .catch((e) => {
                console.error("Failed to update notes:", e);
            });
    };
    


    return (
        <div className="flexAutoCol alignCntr" style={{height:'calc(100% - 56px)'}}>
            {loading && <Loader />}
            <DatePicker date={date} setDate={setDate} setSearch={setSearch} search={search} />
            <div className="flexMinHeightCol pdngXS scrollY" style={{display:'flex',gap:'10px'}}>
                {res &&
                    res.length > 0 &&
                    res.map((each, index) => (
                        // <div className="flexCol pdngXS" key={index}>
                            <div className="flexCol brdrSM pdngXS brdrRadius" key={index}>
                                <span className="cardTxtSm boldTxt">{dateFormat(new Date(each?.updatedAt))}</span>
                                {editIndex === index ? (
                                    <>
                                            <ReactQuill
                                                theme="snow"
                                                value={editedContent}
                                                onChange={setEditedContent}
                                                style={{ marginBottom: "16px" }}
                                                />
                                            <div className="flexRow justfiyEnd"  style={{position:'sticky',backgroundColor:'#fff',bottom:0}}>
                                                <Button
                                                    onClick={handleCancel}
                                                    size='small'
                                                    variant="outlined"
                                                    color="secondary"
                                                    style={{ marginRight: "8px",textTransform:'capitalize'  }}
                                                    >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    size='small'
                                                    style={{ textTransform:'capitalize',color:'#FFF'  }}
                                                    onClick={() => handleSave(each)}
                                                    variant="contained"
                                                    color="primary"
                                                    >
                                                    Save
                                                </Button>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                        <div dangerouslySetInnerHTML={{ __html: each?.notes }} 
                                         style={{
                                             wordWrap: "break-word",
                                             overflowWrap: "break-word",
                                             whiteSpace: "normal",
                                            }} />
                                        <div className="flexRow alignEnd justfiyEnd" style={{position:'sticky',backgroundColor:'#fff',bottom:0}}>
                                        <Button
                                            onClick={() => handleEdit(index, each?.notes)}
                                            variant="outlined"
                                            size='small'
                                            color="primary"
                                            style={{ marginTop: "8px",textTransform:'capitalize' }}
                                            >
                                            Edit
                                        </Button>
                                        </div>
                                    </>
                                )}
                            </div>
                        // </div>
                    ))}
                {!loading && res && res.length <= 0 && <InternalNote data={data} setRes={setRes} />}
                {!loading && res && res.length <= 0 && <NoData src="/images/icons/nodata-64.png" label="No Data Found" />}
            </div>
        </div>
    );
};
export default MedicalHistory;
